import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import ThemedSkeleton from "./ThemedSkeleton";

function UserAvatar({ user, isLoading, ...props }) {

  if (isLoading) {
    return (
      <Avatar {...props}>
        <ThemedSkeleton className="aspect-square h-full w-full" />
      </Avatar>
    );
  }
  return (
    <Avatar {...props}>
      <AvatarImage src={user?.picture} alt={`Avatar of ${user?.name}`} />
      <AvatarFallback>
        {user?.first_name[0] + user?.last_name[0] || "SS"}
      </AvatarFallback>
    </Avatar>
  );
}

export default UserAvatar;
